import type { ThunkAction } from '@reduxjs/toolkit';
import type { RootState } from 'store/index';
import { DiscountsService } from 'store/services/discounts.service';
import type { DiscountItem } from './discounts.slice';
import { discountsActions } from './config';

export const getAllDiscounts =
  (): ThunkAction<void, RootState, unknown, any> => async (dispatch) => {
    try {
      dispatch(discountsActions.setDiscountsPendingStatus(true));
      const response = await DiscountsService.getAllDiscounts();
      dispatch(discountsActions.setDiscounts(response));
    } catch (e: any) {
      throw new Error(e);
    } finally {
      dispatch(discountsActions.setDiscountsPendingStatus(false));
    }
  };

export const createNewDiscount =
  (body: DiscountItem): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch) => {
    try {
      const response = await DiscountsService.createDiscount(body);
      dispatch(discountsActions.setNewDiscount(response));
    } catch (err: any) {
      throw new Error(err);
    }
  };

export const deleteDiscounts =
  (ids: Array<string>): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch) => {
    try {
      dispatch(discountsActions.setDiscountsPendingStatus(true));
      await DiscountsService.removeDiscounts(ids);
      ids.forEach((id) => {
        dispatch(discountsActions.removeDiscount(id));
      });
    } catch (err: any) {
      throw new Error(err);
    } finally {
      dispatch(discountsActions.setDiscountsPendingStatus(false));
    }
  };

export const downloadDiscountsAsXml =
  (): ThunkAction<void, RootState, unknown, any> => async () => {
    try {
      await DiscountsService.downloadDiscountsAsExcel();
    } catch (err: any) {
      throw new Error(err);
    }
  };

export const validateDiscount =
  (code: string): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch) => {
    try {
      const response = await DiscountsService.validateDiscount(code);
      dispatch(discountsActions.setDiscountValidationResult(response));
    } catch (err: any) {
      throw new Error(err);
    }
  };
